import { Address } from "../../models/base";

interface ExtendedField {
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  ref: React.Ref<any>;
}

const generateClearedAddress = (place: any): string => {

  let streetNumber = null;
  let route = null;
  let administrativeArea = null;
  let postalCode = null;
  let locality = null;

  place.address_components.forEach((component: any) => {
    const types = component.types;

    if (types.includes('street_number')) {
      streetNumber = component.long_name;
    }
    if (types.includes('route')) {
      route = component.long_name;
    }
    if (types.includes('administrative_area_level_1')) {
      administrativeArea = component.short_name;
    }
    if (types.includes('postal_code')) {
      postalCode = component.long_name;
    }
    if (types.includes('locality')) {
      locality = component.long_name;
    }
  });
  if (!streetNumber || !route || !locality || !administrativeArea) {
    return ''; 
  }

  const addressParts = [
    streetNumber,
    route,
    locality,
    administrativeArea,
    postalCode
  ];

  return addressParts.filter(part => part).join(' ').trim();

};

export const handleAddressChanged = (
  field: ExtendedField,
  setLocation: (address: Address) => void, //React.Dispatch<React.SetStateAction<Address>>,
  autocompleteRef: React.RefObject<google.maps.places.Autocomplete>
) => {
  if (autocompleteRef.current) {
    const place = autocompleteRef.current.getPlace();
    if (place && place.address_components) {
      const lat = place!.geometry!.location!.lat();
      const lon = place!.geometry!.location!.lng();

      let fullAddress = ''
      const cleared_address = generateClearedAddress(place)
      if (cleared_address === '') {
        fullAddress = place.formatted_address!;
      } else {
        fullAddress = cleared_address
      }

      field.onChange(fullAddress);
      setLocation({
        address: fullAddress,
        coordinates: { lat: lat, lon: lon },
      });
    }
  }
};

export const handleAddressCompanyChanged = (
  field: ExtendedField,
  // setLocation: React.Dispatch<React.SetStateAction<Address>>,
  autocompleteRef: React.RefObject<google.maps.places.Autocomplete>,
  methods: any
) => {
  if (autocompleteRef.current) {
    const place = autocompleteRef.current.getPlace();
    if (place && place.address_components) {

      const lat = place.geometry?.location?.lat() || 0;
      const lon = place.geometry?.location?.lng() || 0;

      let fullAddress = ''
      const cleared_address = generateClearedAddress(place)
      if (cleared_address === '') {
        fullAddress = place.formatted_address!;
      } else {
        fullAddress = cleared_address
      }
    
      methods.setValue("address", {
        address: fullAddress,
        coordinates: { lat, lon }
      });
    }
  }
};
